export const COOKIE_NAME = 'cookieConsent';
